import { createStore, applyMiddleware, type Store, compose } from "redux";
import { thunk as thunkMiddleware } from "redux-thunk";
import { errorHandler } from "~/shared/middleware";
import rootReducer from "~/shared/reducers";

let store: Store;

export function configureStore(initialState, medDevTools = false) {
	const composeEnhancers = (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ as typeof compose) || compose;

	const apply = (...middleware) => {
		if (medDevTools) {
			return composeEnhancers(applyMiddleware(...middleware));
		}
		return applyMiddleware(...middleware);
	};

	store = createStore(rootReducer, initialState, apply(thunkMiddleware, errorHandler));

	return store;
}

export const getStore = () => store;
